import { render, staticRenderFns } from "./DiagnocatModal.vue?vue&type=template&id=533aa1b0&scoped=true"
import script from "./DiagnocatModal.vue?vue&type=script&lang=js"
export * from "./DiagnocatModal.vue?vue&type=script&lang=js"
import style0 from "./DiagnocatModal.vue?vue&type=style&index=0&id=533aa1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533aa1b0",
  null
  
)

export default component.exports